import { render, staticRenderFns } from "./DmDriverLabelList.vue?vue&type=template&id=45f932a1&scoped=true"
import script from "./DmDriverLabelList.vue?vue&type=script&lang=js"
export * from "./DmDriverLabelList.vue?vue&type=script&lang=js"
import style0 from "./DmDriverLabelList.vue?vue&type=style&index=0&id=45f932a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f932a1",
  null
  
)

export default component.exports